<div class="container-forgot">
  <!-- LOGO del progetto -->
  <div class="logo-forgot">
    <a href="https://workinc.vtserver.eu/" target="_blank">
      <img src="img/logo_white.png" [attr.alt]="'auth.logo-alt' | translate" />
    </a>
  </div>

  <div class="forgot-box">

    @if (subbmited==false){
      @if (loadForm==true) {
          <h2>{{ 'auth.reset.title' | translate }}</h2>

          <app-alert-message [iconStyle]="{ top: '0rem', right: '0rem' }"></app-alert-message>

          <form (submit)="submit()">
          
          <label>{{ 'auth.fields.new-password' | translate }}</label>
          <input type="password" name="newPassword" [(ngModel)]="newPassword" placeholder="{{ 'auth.fields.new-password' | translate }}" required />
          <app-password-validation [password]="newPassword" (validityChange)="onPasswordValidityChange($event)" class="password-popup"></app-password-validation>
          <label>{{ 'auth.fields.confirm-password' | translate }}</label>
          <input type="password" name="confirmPassword" [(ngModel)]="confirmPassword" placeholder="{{ 'auth.fields.confirm-password' | translate }}" required />

          <button type="submit" >{{ 'auth.reset.submit' | translate }}</button>

          </form>
      }
      @else {
          <h1>
              {{ 'auth.reset.invalid-token' | translate }}
          </h1>
      }
    }
    @else {

      <h1>
        {{ 'auth.reset.success-title' | translate }}
      </h1>

      <button (click)="toLogin()">
        {{ 'auth.reset.go-login' | translate }}
      </button>

    }
  </div>
</div>
